<template>
    <div class="hot-content" @click="choose()"> <!-- {key: hot_list[hotIndex].hotWord} -->
        <div class="hot-data">
          <div class="hot-item" :style="`top: -${9.06667*hotIndex}vw`" :class="[{'move': isMove}]" v-for="(item, index) in hot_list" :key="index">{{item.hotWord}}</div>
        </div>
    </div>
</template>

<script>
import {get} from 'lodash';

export default {
    name: "hot-swiper",
    props: {
        type: String
    },
    data() {
        return {
            isMove: false,
            hot_list: [],
            hotIndex: 0
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            this.$apis.common.getSearchHotwordList({type: this.type}).then(res => {
                this.hot_list = [...res.data, ...res.data]
                this.$nextTick(() => {
                if(this.hot_list.length > 2) {
                    setTimeout(() => {
                        this.hotMove();
                    }, 5000)
                }
                })
            })
        },

        hotMove() {
            this.isMove = true;
            setTimeout(() => {
                this.isMove = false;
                this.hotIndex = this.hotIndex == (this.hot_list.length/2) - 1? 0 : this.hotIndex+1;
                setTimeout(() => {
                    this.hotMove();
                }, 5000);
            }, 1000)
        },

        choose() {
            // this.$emit("choose", this.hot_list[this.hotIndex].hotWord);
            let type = this.type, placeholder = get(this.hot_list,`[${this.hotIndex}].hotWord`) || '';
            if(type) {
                type = type == '1'? 'cases' : 'product'
            }
            this.$router.push({
                path: "/search",
                query: {type,placeholder}
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.hot-content {
    top: 10px;
    left: 62px;
    left: 15.6vw;
    width: 200px;
    height: 34px;
    position: absolute;
    text-align: left;

    .hot-data {
      position: relative;
      color: #787D85;
      font-size: 14px;
    //   top: 8px;
      top: 0;
      left: 12px;
      height: 34px;
      line-height: 34px;
      overflow: hidden;

      .hot-item {
        position: relative;
        &.move {
          animation:mymove 1s ease-in-out;
          animation-fill-mode: forwards;
        }
        // top: -16px;
      }
    }
}
@keyframes mymove
{
    from {transform: translateY(0px);}
    to {transform: translateY(-34px);}
}
</style>



// WEBPACK FOOTER //
// src/components/common/hotSwiper.vue